<template>
<div class="chapter">
<div class="inner_page">
<a id="piv"></a>
<div class="copyright">
<p class="center ">Copyright © 2009 by L. Jon Wertheim</p>
<p class="center spaceabove1">All rights reserved</p>
<p class="center spaceabove1">For information about permission to reproduce selections from this book, write to <a href="mailto:trade.permissions@hmhco.com">trade.permissions@hmhco.com</a> or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.</p>
<p class="center spaceabove1"><a href="https://hmhbooks.com/" target="_blank">hmhbooks.com</a></p>
<p class="center spaceabove1"><em>The Library of Congress has cataloged the print edition as follows:</em><br/>
Wertheim, L. Jon.<br/>
Strokes of genius : Federer, Nadal, and the greatest<br/>
match ever played / L. Jon Wertheim.</p>
<p class="center ">p. cm.<br/>
<span class="smallcaps">ISBN</span> 978-0-547-23280-5</p>
<p class="center ">1. Wimbledon Championships. 2. Federer, Roger, 1981– 3. Nadal, Rafael, 1986– I. Title.</p>
<p class="center "><span class="smallcaps">GV</span>999.<span class="smallcaps">W</span>47 2009<br/>
796.34209421'2—dc22 2009005595</p>
<p class="center spaceabove1">e<span class="smallcaps">ISBN</span> 978-0-547-41649-6<br/>
v5.1220</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front01.vue?7602cbf9